import PropTypes from 'prop-types';

import Header from './Header';
import SearchableDataTable from '../DataTable/SearchableDataTable';
import SortingDataTable from '../DataTable/SortingDataTable';

const SettingDataTable = ({
  data,
  headerOptions,
  tableOptions,
  searching,
}) => {
  const hasSetting = data?.length > 0;

  return (
    <div>
      <Header {...headerOptions} />
      <hr className="my-8" />
      {hasSetting && searching && <SearchableDataTable {...{ data, ...tableOptions }} />}
      {hasSetting && !searching && <SortingDataTable {...{ data, ...tableOptions }} />}
      {!hasSetting && <div>No data</div>}
    </div>
  );
};

SettingDataTable.propTypes = {
  data: PropTypes.array.isRequired,
  headerOptions: PropTypes.any.isRequired,
  tableOptions: PropTypes.any.isRequired,
  searching: PropTypes.bool,
};

export default SettingDataTable;
